/* eslint-disable jsx-a11y/label-has-for */

import React from 'react'
import PropTypes from 'prop-types'
import 'icheck/skins/all.css'
import { Checkbox, Radio } from 'react-icheck'

const globalPermissions = [
  'MANAGE_USERS',
  'MANAGE_TENANTS',
  'MANAGE_WIDGETS',
  'MANAGE_OWN_WIDGETS'
]
const roles = [null, 'widget_owner', 'admin']

const PermissionsForm = ({
  role,
  permissions,
  reminderLimit,
  onSave,
  updateRole,
  onReset,
  updatePermissions,
  updateReminderLimit
}) => {
  const reminderLimitChangedHandler = event => {
    if (event.target.value) {
      return updateReminderLimit(parseInt(event.target.value, 10))
    }
  }

  return (
    <div>
      <div className='portlet light' style={{ border: '1px solid #bbb' }}>
        <div className='form-group'>
          <label className='control-label'>Roles</label>
          <div className='input-group'>
            <div className='icheck-inline'>
              {roles.map(r => (
                <Radio
                  key={r}
                  name='role'
                  radioClass='iradio_square-aero'
                  label={r || 'None'}
                  checked={r === role}
                  onChange={() => updateRole(r)}
                />
              ))}
            </div>
          </div>
        </div>

        <div className='form-group'>
          <label className='control-label'>Permissions</label>
          <div className='input-group'>
            <div className='icheck-list'>
              {globalPermissions.map(permission => (
                <Checkbox
                  key={permission}
                  checkboxClass='icheckbox_square-aero'
                  label={permission.replace(/_/g, ' ')}
                  checked={Boolean(
                    permissions && permissions.includes(permission)
                  )}
                  onChange={({ target }) =>
                    updatePermissions(target.checked, permission)}
                />
              ))}
            </div>
          </div>
        </div>

        <div className='form-group'>
          <label className='control-label'>Self Service</label>
          <div className='input-group' style={{
            display: 'flex',
            alignItems: 'center'
          }}>
            <label style={{ marginRight: 10, alignContent: 'center' }}>
              Reminder Limit
            </label>
            <input
              type='number'
              id='reminder-limit'
              min={1}
              className='form-control'
              value={reminderLimit}
              onChange={reminderLimitChangedHandler}
              style={{
                width: 80,
                marginLeft: 10
              }} />
          </div>
        </div>

        <div className='text-left'>
          <button className='btn green' onClick={onSave}>
            <i className='fa fa-check' /> Save Role and Permissions
          </button>
          <button className='btn red' onClick={onReset} style={{ marginLeft: 5 }}>
            Cancel
          </button>
        </div>
        <div className='clearfix' />
      </div>
    </div>
  )
}

PermissionsForm.displayName = 'PermissionsF'

PermissionsForm.propTypes = {
  role: PropTypes.oneOf(roles),
  permissions: PropTypes.string,
  reminderLimit: PropTypes.number,
  onSave: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  updatePermissions: PropTypes.func.isRequired,
  updateRole: PropTypes.func.isRequired,
  updateReminderLimit: PropTypes.func.isRequired
}

export default PermissionsForm



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/user-permissions/permissions-form.js